import React from 'react';
import { forEach as _forEach } from 'lodash';

export const mailReplaceMap = {
  firstName: 'recipients_first_name',
  lastName: 'recipients_last_name',
  company: 'senders_company_name',
};

export const getMailReplaceMap = messages => {
  const res = {};

  _forEach(mailReplaceMap, (translationKey, replaceKey) => {
    res[replaceKey] = messages[translationKey];
  });

  return res;
};

export const renderMailReplaceKeys = (messages, keys = 'all') => {
  const res = [];

  _forEach(getMailReplaceMap(messages), (explanation, replaceKey) => {
    if (keys === 'all' || keys.indexOf(replaceKey) > -1) {
      res.push(
        <React.Fragment key={replaceKey}>
          <dt>%{replaceKey}%</dt>
          <dd>{explanation}</dd>
        </React.Fragment>
      );
    }
  });

  return res;
};
